import {
  ADD_POPUP,
  ADD_USER_EVENT_TO_MULTI_VIEW,
  CLEAR_USER_MULTI_VIEW,
  REMOVE_USER_EVENT_FROM_MULTI_VIEW,
} from '@/store/actionTypes';
import {
  ADD_EVENT_TO_MULTI_VIEW, CLEAR_MULTI_VIEW,
  DELETE_POPUP,
  REMOVE_EVENT_FROM_MULTI_VIEW,
  SET_POPUP_DATA,
} from '@/store/mutationTypes';
import {ERROR_CODE_NAME} from '@/const';
import {GET_USER_DATA} from '@/store/getterTypes';

export default {
  async [ADD_POPUP]({state, commit}, data = {}) {
    const {
      component,
      ...attrs
    } = data;
    let res;
    let rej;

    const promise = new Promise((resolve, reject) => {
      res = resolve;
      rej = () => reject(new Error(ERROR_CODE_NAME.ABORT));
    });

    const props = {
      component,
      ok: res,
      cancel: rej,
      attrs,
      currentIndex: state.popupList.length,
    };
    commit(SET_POPUP_DATA, {
      props,
    });
    promise
        .catch(() => {})
        .finally(() => {
          commit(DELETE_POPUP, props);
        });

    return promise;
  },
  [ADD_USER_EVENT_TO_MULTI_VIEW]({getters, commit}, event) {
    const userId = getters[GET_USER_DATA]?.id;
    commit(ADD_EVENT_TO_MULTI_VIEW, {event, userId});
  },
  [REMOVE_USER_EVENT_FROM_MULTI_VIEW]({getters, commit}, clearId) {
    const userId = getters[GET_USER_DATA]?.id;
    commit(REMOVE_EVENT_FROM_MULTI_VIEW, {clearId, userId});
  },
  [CLEAR_USER_MULTI_VIEW]({getters, commit}) {
    const userId = getters[GET_USER_DATA]?.id;
    commit(CLEAR_MULTI_VIEW, {userId});
  },
};
